// The legacy shell uses sibling sidebar/content elements on every route.
// Keep one listener set per mounted sidebar and reset at the mobile breakpoint.
export function mountResponsiveSidebar(sidebar) {
    const content = document.getElementById('content');
    const toggle = document.getElementById('sidebarCollapse');
    const backdrop = sidebar.parentNode.querySelector('.sidebar-backdrop');
    const closeButton = sidebar.querySelector('.sidebar-close');
    const media = window.matchMedia('(max-width: 768px)');
    let open = !media.matches;
    // Report styles are imported globally. Mark only mounted dashboard screens
    // so their fixed paper width cannot resize or hide the application shell.
    document.documentElement.classList.add('eduprime-dashboard');
    document.body.classList.add('eduprime-dashboard');

    const setOpen = (next, focusMenu = false) => {
        if (!next && content) content.inert = false;
        if (!next && sidebar.contains(document.activeElement) && toggle) toggle.focus();
        open = next;
        sidebar.classList.toggle('active', media.matches ? open : !open);
        if (content) {
            content.classList.toggle('active', !open || media.matches);
            content.inert = media.matches && open;
        }
        sidebar.inert = !open;
        sidebar.setAttribute('aria-hidden', String(!open));
        if (toggle) toggle.setAttribute('aria-expanded', String(open));
        if (focusMenu && media.matches && open && closeButton) closeButton.focus();
    };
    const onToggle = () => setOpen(!open, true);
    const onClose = () => setOpen(false);
    const onMediaChange = () => {
        const transitions = [sidebar, content].filter(Boolean).map(node => ({
            node, value: node.style.getPropertyValue('transition'), priority: node.style.getPropertyPriority('transition')
        }));
        // A breakpoint changes the desktop/mobile layout at once. Only user toggles should animate.
        transitions.forEach(({node}) => node.style.setProperty('transition', 'none', 'important'));
        setOpen(!media.matches);
        transitions.forEach(({node}) => node.getBoundingClientRect());
        transitions.forEach(({node, value, priority}) => {
            if (value) node.style.setProperty('transition', value, priority);
            else node.style.removeProperty('transition');
        });
    };
    const onLink = (event) => {
        const link = event.target.closest('a[href]');
        if (media.matches && link && !link.getAttribute('href').startsWith('#') &&
            link.getAttribute('data-toggle') !== 'collapse') setOpen(false);
    };
    const onKey = (event) => {
        if (!media.matches || !open) return;
        if (event.key === 'Escape') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Tab') {
            const controls = Array.from(sidebar.querySelectorAll('a[href], button, input, select, textarea, [tabindex="0"]'))
                .filter(node => !node.disabled && node.getClientRects().length > 0);
            const first = controls[0];
            const last = controls[controls.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                if (last) last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                if (first) first.focus();
            }
        }
    };

    if (toggle) toggle.addEventListener('click', onToggle);
    if (backdrop) backdrop.addEventListener('click', onClose);
    if (closeButton) closeButton.addEventListener('click', onClose);
    sidebar.addEventListener('click', onLink);
    document.addEventListener('keydown', onKey);
    if (media.addEventListener) media.addEventListener('change', onMediaChange);
    else media.addListener(onMediaChange);
    setOpen(open);

    return () => {
        if (toggle) toggle.removeEventListener('click', onToggle);
        if (backdrop) backdrop.removeEventListener('click', onClose);
        if (closeButton) closeButton.removeEventListener('click', onClose);
        sidebar.removeEventListener('click', onLink);
        document.removeEventListener('keydown', onKey);
        if (media.removeEventListener) media.removeEventListener('change', onMediaChange);
        else media.removeListener(onMediaChange);
        if (content) content.inert = false;
        document.documentElement.classList.remove('eduprime-dashboard');
        document.body.classList.remove('eduprime-dashboard');
    };
}
